
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.1717',
  depVersions: {
  "customer-portal-app": "static-1.1717",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.449",
  "data-fetching-client": "static-1.9495",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.405",
  "growth-payments-core": "static-1.24778",
  "head-dlb": "static-1.4841",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5412",
  "hs-test-utils": "static-1.7823",
  "hub-http": "static-1.6038",
  "hub-http-shared-msw-handlers": "static-1.9520",
  "hubspot-dlb": "static-2.1806",
  "hubspot-prosemirror": "static-1.17655",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11249",
  "I18n": "static-7.1575",
  "immutable": "static-2.19",
  "jasmine-runner": "static-1.6290",
  "payment-link-components": "static-1.22989",
  "prosemirror": "static-1.13",
  "quartz": "static-1.6759",
  "quartz-core": "static-1.5978",
  "react": "static-7.180",
  "react-colorpicker": "static-2.10029",
  "react-dlb": "static-1.73",
  "react-utils": "static-2.5192",
  "rich-text-lib": "static-1.19505",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.17685",
  "ui-components-test-utils": "static-1.5387",
  "UIComponents": "static-3.8196",
  "foundations-assets": "static-1.4654",
  "foundations-components": "static-1.7562",
  "foundations-theming": "static-1.4230",
  "foundations-theming-specialty": "static-1.1946",
  "framer-motion": "static-1.68",
  "history": "static-4.47",
  "metrics-js": "static-1.9436",
  "PortalIdParser": "static-2.367",
  "portals-platform-lib": "static-1.562",
  "quartz-config": "static-1.537",
  "quartz-routing": "static-1.189",
  "quick-fetch": "static-1.3754",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16470",
  "react-router-dom": "static-5.26",
  "sanitize-text": "static-1.7963",
  "styled-components": "static-2.85",
  "tanstack-table": "static-1.51",
  "ui-addon-draggable": "static-3.4584",
  "ui-addon-react-router-dom": "static-1.9364",
  "usage-tracker": "static-1.7154",
  "usage-tracker-anonymous": "static-1.5571",
  "usage-tracker-core": "static-1.7004",
  "apollo-stack-hubspot": "static-3.79",
  "hs-promise-rejection-tracking": "static-1.5387",
  "raven": "static-3.5725",
  "raven-hubspot": "static-1.6032",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3246",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3036",
  "quartz-webpack": "static-1.2983",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.78",
  "customer-data-objects": "static-1.7467",
  "frontend-preferences-client": "static-1.7743",
  "laboratory-lib": "static-3.6978",
  "onboarding-scopes": "static-1.6281",
  "rpc-client-utils": "static-1.4453",
  "ui-addon-opt": "static-4.8202",
  "HeadJS": "static-2.713",
  "hs-test-utils-bend-plugin": "static-1.2934",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "ts-schema": "static-1.3922",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7477",
  "cssUtils": "static-1.737",
  "customer-data-ui-utilities": "static-1.9641",
  "HubStyle": "static-2.11557",
  "knowledge-content-types": "static-1.8386",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.434",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.484",
  "ui-addon-emoji-picker": "static-1.9706",
  "ui-addon-i18n": "static-1.10962",
  "ui-business-units-lib": "static-1.8847",
  "ui-shepherd-react": "static-3.9965",
  "video-components-external": "static-1.10623",
  "i18n-data": "static-1.217",
  "moment-timezone": "static-5.79",
  "jasmine": "static-4.4145",
  "commerce-tours-lib": "static-1.5748",
  "customer-data-properties": "static-1.50851",
  "getting-started-shared-tasks": "static-1.17936",
  "growth-onboarding-reliability": "static-1.4905",
  "onboarding-tours": "static-1.16293",
  "reference-resolvers-lite": "static-1.7913",
  "sales-checkout-service-client": "static-1.3486",
  "ui-addon-iframeable": "static-1.8865",
  "user-context": "static-1.4917",
  "dispatcher": "static-1.132",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.798",
  "hubspotter-http": "static-1.4495",
  "icons": "static-2.623",
  "mobile-manifest-mixins": "static-1.486",
  "module-federation": "static-1.19",
  "quartz-auth": "static-1.434",
  "quartz-head": "static-1.424",
  "quartz-test": "static-1.434",
  "quartz-tracking": "static-1.138",
  "ui-fonts": "static-1.511",
  "usage-tracker-container": "static-1.7144",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9244",
  "data-token-picker": "static-1.16076",
  "FileManagerLib": "static-1.38594",
  "property-translator": "static-1.5229",
  "atom": "static-1.4888",
  "merchandise-lib": "static-1.260",
  "purchase-motions-components": "static-1.5508",
  "salesImages": "static-1.521",
  "SharedI18nStrings": "static-1.180",
  "foundations-components-test-utils": "static-1.5045",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.95",
  "ui-images": "static-2.1097",
  "bend-plugin-foundations-components": "static-1.3831",
  "floating-ui": "static-1.52",
  "react-aria": "static-1.62",
  "trellis-assets": "static-1.1271",
  "bend-plugin-foundations-theming": "static-1.2713",
  "foundations-theming-base": "static-1.3215",
  "stylex": "static-1.28",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5568",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4293",
  "react-flip-move": "static-1.66",
  "bender-build-tools": "static-1.2970",
  "inbound-db-properties-service-client": "static-1.3692",
  "superstore": "static-1.4588",
  "feedback-loader": "static-1.28896",
  "ai-components-ui-library": "static-1.8400",
  "ui-addon-video-player": "static-1.8515",
  "ui-coaching-tips": "static-1.27992",
  "sassPrefix": "static-1.152",
  "react-dnd-compat": "static-1.4439",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2306",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7980",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4470",
  "content-media-composition-data-lib": "static-1.11526",
  "content-media-compositions": "static-2.15533",
  "idb-keyval": "static-1.40",
  "immer": "static-1.33",
  "immerable": "static-1.3973",
  "magpie-lib": "static-1.5413",
  "magpie-types": "static-1.4873",
  "media-bridge-lib": "static-1.18599",
  "video-data-lib": "static-1.34281",
  "commerce-products-lib": "static-1.8912",
  "crm-message-bus": "static-1.42417",
  "growth-data-modal": "static-1.5177",
  "hubspot-apollo-client": "static-1.4699",
  "onboarding-tours-client": "static-1.4507",
  "calling-global-api": "static-1.63744",
  "calling-internal-common": "static-1.31113",
  "calling-lifecycle-internal": "static-1.65126",
  "calling-lifecycle-messages": "static-1.57420",
  "conditional-properties-service-client": "static-1.3641",
  "crm-links": "static-1.6085",
  "customer-data-objects-ui-components": "static-1.12827",
  "customer-data-property-utils": "static-1.7898",
  "external-options-client-types": "static-1.4002",
  "file-manager-components": "static-1.22954",
  "framework-data-schema-resolvers": "static-1.6691",
  "google-libphonenumber": "static-1.34",
  "hs-entities": "static-1.498",
  "inbound-db-meta-service-client": "static-1.3438",
  "inbounddb-objects-service-types": "static-1.4065",
  "meetings-icalendar-utils-lib": "static-1.451",
  "multi-currency-client-types": "static-1.3534",
  "object-builder-ui-client": "static-1.48053",
  "pipeline-validation-client-types": "static-1.3806",
  "property-value-citations": "static-1.1465",
  "pulse": "static-1.334",
  "smart-property-lib": "static-1.5986",
  "tiered-pricing": "static-1.857",
  "ui-addon-form-validation": "static-1.10813",
  "growth-onboarding-confetti": "static-1.2890",
  "growth-onboarding-next-action-utils": "static-1.1338",
  "navigation-components": "static-1.17330",
  "onboarding-tours-utils": "static-1.359",
  "ui-shepherd-tracker": "static-1.7346",
  "ui-universal-auth": "static-1.8725",
  "batch-promise": "static-1.1369",
  "navigation-messaging": "static-1.6657",
  "getting-started-shared-tasks-store": "static-1.17054",
  "hubspotter-http-shared-msw-handlers": "static-1.9518",
  "audio-components": "static-1.5639",
  "FileManagerCore": "static-1.38453",
  "FileManagerImages": "static-1.36105",
  "video-components": "static-1.12626",
  "foundations-components-legacy": "static-1.587",
  "growth-monetization-service-types": "static-1.4329",
  "nav-client-types": "static-1.2176",
  "purchase-motions-api": "static-1.5511",
  "self-service-api": "static-1.10057",
  "signup-constants": "static-1.18459",
  "signup-ui-url-generator": "static-2.7858",
  "trials-service-types": "static-1.3730",
  "usage-tracker-public": "static-1.6965",
  "chatspot-core": "static-1.20409",
  "chirp-fetch": "static-1.1701",
  "ContentUtils": "static-1.67676",
  "copilot-toolkit": "static-1.10582",
  "growth-onboarding-feedback-components": "static-1.6401",
  "hls.js": "static-1.35",
  "reactive-lib": "static-1.543",
  "simple-logging-lib": "static-1.2869",
  "commerce-permissions": "static-1.578",
  "customer-data-tracking": "static-1.6700",
  "products-iframe-lib": "static-1.7376",
  "products-ui-components-shared-msw-handlers": "static-1.9902",
  "hubspot-apollo-cache": "static-1.158",
  "calling-error-reporting": "static-1.31119",
  "shared-worker-versioning": "static-1.10857",
  "calling-usage-tracker": "static-1.6359",
  "voice-sms-access-library": "static-1.299",
  "conversations-skeleton-state": "static-1.7067",
  "location-customization-utils-lib": "static-1.8622",
  "crm-pipelines-api-client-types": "static-1.3983",
  "framework-builder-read-service-client": "static-1.3851",
  "framework-data-schema-quick-fetch": "static-1.6596",
  "persist-promise": "static-1.3526",
  "directed-graph": "static-1.758",
  "event-emitter": "static-1.766",
  "breeze-intelligence-kit": "static-1.5349",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9603",
  "fsm": "static-1.3550",
  "policy-lib": "static-1.6606",
  "react-tinymce": "static-1.54671",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9666",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53797",
  "tinymce-plugins": "static-1.56911",
  "tinymce-themes": "static-1.55767",
  "growth-onboarding-next-action-components": "static-1.1366",
  "user-context-client": "static-1.4477",
  "unified-auth-core-lib": "static-1.520",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4350",
  "video-embed": "static-1.35115",
  "content-icons-ui": "static-1.2161",
  "social-insights-client-types": "static-1.21421",
  "eligibility-engine-service-types": "static-1.3011",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4625",
  "integrations-lib": "static-1.15483",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4105",
  "calling-orchestration-schema": "static-1.35076",
  "crm-record-cards-service-types": "static-1.3460",
  "highcharts": "static-8.100",
  "trellis-story-utils": "static-1.4339",
  "storybook-react": "static-1.29",
  "hub-http-contrib": "static-1.2861",
  "interframe": "static-3.4607",
  "tinymce-data": "static-1.39882",
  "ui-addon-sales-email": "static-1.5032",
  "codemirror": "static-5.91",
  "layout-dnd-components": "static-1.12073",
  "layout-dnd-utils": "static-1.11048",
  "react-codemirror": "static-1.10445",
  "ui-brand-identity-lib": "static-1.14000",
  "NamespacedHubStyle": "static-2.8914",
  "outpost": "static-1.4023",
  "flux-actions": "static-1.310",
  "integrations-error-boundary-lib": "static-1.12898",
  "integrations-tracking-lib": "static-1.5407",
  "native-integrations-shared-strings": "static-1.7607",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10191",
  "rxjs": "static-5.10",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67751",
  "layout-data-lib": "static-1.9373",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.2818",
  "advanced-menus-core": "static-1.14844",
  "advanced-menus-lib": "static-1.11815",
  "ExportDialog": "static-6.10205",
  "ui-memberships-settings-lib": "static-1.33489",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14843",
  "simple-menus-lib": "static-1.16360"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.1717",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.449",
  "data-fetching-client": "/data-fetching-client/static-1.9495",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.405",
  "growth-payments-core": "/growth-payments-core/static-1.24778",
  "head-dlb": "/head-dlb/static-1.4841",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5412",
  "hs-test-utils": "/hs-test-utils/static-1.7823",
  "hub-http": "/hub-http/static-1.6038",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9520",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17655",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11249",
  "I18n": "/I18n/static-7.1575",
  "immutable": "/immutable/static-2.19",
  "jasmine-runner": "/jasmine-runner/static-1.6290",
  "payment-link-components": "/payment-link-components/static-1.22989",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.6759",
  "quartz-core": "/quartz-core/static-1.5978",
  "react": "/react/static-7.180",
  "react-colorpicker": "/react-colorpicker/static-2.10029",
  "react-dlb": "/react-dlb/static-1.73",
  "react-utils": "/react-utils/static-2.5192",
  "rich-text-lib": "/rich-text-lib/static-1.19505",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17685",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5387",
  "UIComponents": "/UIComponents/static-3.8196",
  "foundations-assets": "/foundations-assets/static-1.4654",
  "foundations-components": "/foundations-components/static-1.7562",
  "foundations-theming": "/foundations-theming/static-1.4230",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1946",
  "framer-motion": "/framer-motion/static-1.68",
  "history": "/history/static-4.47",
  "metrics-js": "/metrics-js/static-1.9436",
  "PortalIdParser": "/PortalIdParser/static-2.367",
  "portals-platform-lib": "/portals-platform-lib/static-1.562",
  "quartz-config": "/quartz-config/static-1.537",
  "quartz-routing": "/quartz-routing/static-1.189",
  "quick-fetch": "/quick-fetch/static-1.3754",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16470",
  "react-router-dom": "/react-router-dom/static-5.26",
  "sanitize-text": "/sanitize-text/static-1.7963",
  "styled-components": "/styled-components/static-2.85",
  "tanstack-table": "/tanstack-table/static-1.51",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4584",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9364",
  "usage-tracker": "/usage-tracker/static-1.7154",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5571",
  "usage-tracker-core": "/usage-tracker-core/static-1.7004",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5387",
  "raven": "/raven/static-3.5725",
  "raven-hubspot": "/raven-hubspot/static-1.6032",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3246",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3036",
  "quartz-webpack": "/quartz-webpack/static-1.2983",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.78",
  "customer-data-objects": "/customer-data-objects/static-1.7467",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7743",
  "laboratory-lib": "/laboratory-lib/static-3.6978",
  "onboarding-scopes": "/onboarding-scopes/static-1.6281",
  "rpc-client-utils": "/rpc-client-utils/static-1.4453",
  "ui-addon-opt": "/ui-addon-opt/static-4.8202",
  "HeadJS": "/HeadJS/static-2.713",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2934",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "ts-schema": "/ts-schema/static-1.3922",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7477",
  "cssUtils": "/cssUtils/static-1.737",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9641",
  "HubStyle": "/HubStyle/static-2.11557",
  "knowledge-content-types": "/knowledge-content-types/static-1.8386",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.434",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.484",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9706",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10962",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8847",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9965",
  "video-components-external": "/video-components-external/static-1.10623",
  "i18n-data": "/i18n-data/static-1.217",
  "moment-timezone": "/moment-timezone/static-5.79",
  "jasmine": "/jasmine/static-4.4145",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5748",
  "customer-data-properties": "/customer-data-properties/static-1.50851",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17936",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4905",
  "onboarding-tours": "/onboarding-tours/static-1.16293",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7913",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3486",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8865",
  "user-context": "/user-context/static-1.4917",
  "dispatcher": "/dispatcher/static-1.132",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.798",
  "hubspotter-http": "/hubspotter-http/static-1.4495",
  "icons": "/icons/static-2.623",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.486",
  "module-federation": "/module-federation/static-1.19",
  "quartz-auth": "/quartz-auth/static-1.434",
  "quartz-head": "/quartz-head/static-1.424",
  "quartz-test": "/quartz-test/static-1.434",
  "quartz-tracking": "/quartz-tracking/static-1.138",
  "ui-fonts": "/ui-fonts/static-1.511",
  "usage-tracker-container": "/usage-tracker-container/static-1.7144",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9244",
  "data-token-picker": "/data-token-picker/static-1.16076",
  "FileManagerLib": "/FileManagerLib/static-1.38594",
  "property-translator": "/property-translator/static-1.5229",
  "atom": "/atom/static-1.4888",
  "merchandise-lib": "/merchandise-lib/static-1.260",
  "purchase-motions-components": "/purchase-motions-components/static-1.5508",
  "salesImages": "/salesImages/static-1.521",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5045",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.95",
  "ui-images": "/ui-images/static-2.1097",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3831",
  "floating-ui": "/floating-ui/static-1.52",
  "react-aria": "/react-aria/static-1.62",
  "trellis-assets": "/trellis-assets/static-1.1271",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2713",
  "foundations-theming-base": "/foundations-theming-base/static-1.3215",
  "stylex": "/stylex/static-1.28",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5568",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4293",
  "react-flip-move": "/react-flip-move/static-1.66",
  "bender-build-tools": "/bender-build-tools/static-1.2970",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3692",
  "superstore": "/superstore/static-1.4588",
  "feedback-loader": "/feedback-loader/static-1.28896",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8400",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8515",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27992",
  "sassPrefix": "/sassPrefix/static-1.152",
  "react-dnd-compat": "/react-dnd-compat/static-1.4439",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2306",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7980",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4470",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11526",
  "content-media-compositions": "/content-media-compositions/static-2.15533",
  "idb-keyval": "/idb-keyval/static-1.40",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3973",
  "magpie-lib": "/magpie-lib/static-1.5413",
  "magpie-types": "/magpie-types/static-1.4873",
  "media-bridge-lib": "/media-bridge-lib/static-1.18599",
  "video-data-lib": "/video-data-lib/static-1.34281",
  "commerce-products-lib": "/commerce-products-lib/static-1.8912",
  "crm-message-bus": "/crm-message-bus/static-1.42417",
  "growth-data-modal": "/growth-data-modal/static-1.5177",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4699",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4507",
  "calling-global-api": "/calling-global-api/static-1.63744",
  "calling-internal-common": "/calling-internal-common/static-1.31113",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65126",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57420",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3641",
  "crm-links": "/crm-links/static-1.6085",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12827",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7898",
  "external-options-client-types": "/external-options-client-types/static-1.4002",
  "file-manager-components": "/file-manager-components/static-1.22954",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6691",
  "google-libphonenumber": "/google-libphonenumber/static-1.34",
  "hs-entities": "/hs-entities/static-1.498",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3438",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4065",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.451",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3534",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48053",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3806",
  "property-value-citations": "/property-value-citations/static-1.1465",
  "pulse": "/pulse/static-1.334",
  "smart-property-lib": "/smart-property-lib/static-1.5986",
  "tiered-pricing": "/tiered-pricing/static-1.857",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10813",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2890",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1338",
  "navigation-components": "/navigation-components/static-1.17330",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.359",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7346",
  "ui-universal-auth": "/ui-universal-auth/static-1.8725",
  "batch-promise": "/batch-promise/static-1.1369",
  "navigation-messaging": "/navigation-messaging/static-1.6657",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17054",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9518",
  "audio-components": "/audio-components/static-1.5639",
  "FileManagerCore": "/FileManagerCore/static-1.38453",
  "FileManagerImages": "/FileManagerImages/static-1.36105",
  "video-components": "/video-components/static-1.12626",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.587",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4329",
  "nav-client-types": "/nav-client-types/static-1.2176",
  "purchase-motions-api": "/purchase-motions-api/static-1.5511",
  "self-service-api": "/self-service-api/static-1.10057",
  "signup-constants": "/signup-constants/static-1.18459",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7858",
  "trials-service-types": "/trials-service-types/static-1.3730",
  "usage-tracker-public": "/usage-tracker-public/static-1.6965",
  "chatspot-core": "/chatspot-core/static-1.20409",
  "chirp-fetch": "/chirp-fetch/static-1.1701",
  "ContentUtils": "/ContentUtils/static-1.67676",
  "copilot-toolkit": "/copilot-toolkit/static-1.10582",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6401",
  "hls.js": "/hls.js/static-1.35",
  "reactive-lib": "/reactive-lib/static-1.543",
  "simple-logging-lib": "/simple-logging-lib/static-1.2869",
  "commerce-permissions": "/commerce-permissions/static-1.578",
  "customer-data-tracking": "/customer-data-tracking/static-1.6700",
  "products-iframe-lib": "/products-iframe-lib/static-1.7376",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9902",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.158",
  "calling-error-reporting": "/calling-error-reporting/static-1.31119",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10857",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6359",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.299",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7067",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8622",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3983",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3851",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6596",
  "persist-promise": "/persist-promise/static-1.3526",
  "directed-graph": "/directed-graph/static-1.758",
  "event-emitter": "/event-emitter/static-1.766",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5349",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9603",
  "fsm": "/fsm/static-1.3550",
  "policy-lib": "/policy-lib/static-1.6606",
  "react-tinymce": "/react-tinymce/static-1.54671",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9666",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53797",
  "tinymce-plugins": "/tinymce-plugins/static-1.56911",
  "tinymce-themes": "/tinymce-themes/static-1.55767",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1366",
  "user-context-client": "/user-context-client/static-1.4477",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.520",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4350",
  "video-embed": "/video-embed/static-1.35115",
  "content-icons-ui": "/content-icons-ui/static-1.2161",
  "social-insights-client-types": "/social-insights-client-types/static-1.21421",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3011",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4625",
  "integrations-lib": "/integrations-lib/static-1.15483",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4105",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35076",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3460",
  "highcharts": "/highcharts/static-8.100",
  "trellis-story-utils": "/trellis-story-utils/static-1.4339",
  "storybook-react": "/storybook-react/static-1.29",
  "hub-http-contrib": "/hub-http-contrib/static-1.2861",
  "interframe": "/interframe/static-3.4607",
  "tinymce-data": "/tinymce-data/static-1.39882",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5032",
  "codemirror": "/codemirror/static-5.91",
  "layout-dnd-components": "/layout-dnd-components/static-1.12073",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11048",
  "react-codemirror": "/react-codemirror/static-1.10445",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14000",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8914",
  "outpost": "/outpost/static-1.4023",
  "flux-actions": "/flux-actions/static-1.310",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12898",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5407",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7607",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10191",
  "rxjs": "/rxjs/static-5.10",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67751",
  "layout-data-lib": "/layout-data-lib/static-1.9373",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2818",
  "advanced-menus-core": "/advanced-menus-core/static-1.14844",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11815",
  "ExportDialog": "/ExportDialog/static-6.10205",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33489",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14843",
  "simple-menus-lib": "/simple-menus-lib/static-1.16360"
}
};
